import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Skeleton } from '@src/shared/ui/components/Widget/components/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: RiskScoreCombination
 *
 * @TODO Needs description.
 *
 * @param riskCodes
 * @param data
 * @returns {Element}
 * @constructor
 */
export function RiskScoreCombination({
  riskCodes = [],
  data = {
    data: {
      content: [],
    },
    defaultView: 'table',
    description: '',
    name: 'Risk Score Combinations',
    riskCodes: [],
  },
}) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/RiskScoreCombination/RiskScoreCombination.jsx">
      {isEmpty(data) ? (
        <Skeleton />
      ) : (
        <Widget description={data?.description || ''} title={data?.name || 'Risk Score Combinations'}>
          {data?.defaultView === 'table' && (
            <Table
              riskCodes={riskCodes}
              rows={data?.data?.content?.map((row) => {
                return {
                  amount: row?.total,
                  code: row?.label,
                };
              })}
            />
          )}
        </Widget>
      )}
    </ErrorHandler>
  );
}
